import { IAppState } from 'shared/common/state';

import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery, selectQueryString } from '../results';

export const selectEarlyAccessUrl = (state: IAppState) => {
  const queryString = selectQueryString(state);
  const jsonQuery = selectJsonQuery(state);
  const isEarlyAccessEnabled = Boolean(getTermValue('is_early_access_enabled')(jsonQuery));

  if (isEarlyAccessEnabled) {
    return null;
  }

  return `/cat.php?${queryString}&is_early_access_enabled=1`;
};
